<template>
    <div class="o-container">
        <div class="o-box u-bg-color-5 -box-padding-sm">
            <h3 class="o-title-3">{{ t("Personnes-ressources selon votre programme") }}</h3>
            <h4 class="o-title-4">{{ t("Veuillez sélectionner un type et un nom de programme :") }}</h4>
            <div class="o-box__inner">
                <div class="o-box__item">
                    <div class="o-form">
                        <div class="o-form-row -col-1/2">
                            <div class="o-form__item">
                                <div class="o-select__wrap">
                                    <label class="o-label sr-only" for="admission-type"></label>
                                    <select class="o-select" v-model="selectedFilter1">
                                        <option value="">{{ t("Sélectionner un type de programme") }}</option>
                                        <option v-for="f in filter1" :value="f" v-html="formatFilter(f)"></option>
                                    </select>
                                    <svg class="o-ico -ico-arrow-down" aria-hidden="true" tabindex="-1" role="img">
                                        <use xlink:href="/assets/img/sprite.svg#arrow-down"></use>
                                    </svg>
                                </div>
                            </div>
                            <div class="o-form__item">
                                <div class="o-select__wrap">
                                    <label class="o-label sr-only" for="admission-type"></label>
                                    <select class="o-select" v-model="selectedFilter2">
                                        <option value="">{{ t("Sélectionner un nom de programme") }}</option>
                                        <option v-for="f in filter2" :value="f" v-html="formatFilter(f)"></option>
                                    </select>
                                    <svg class="o-ico -ico-arrow-down" aria-hidden="true" tabindex="-1" role="img">
                                        <use xlink:href="/assets/img/sprite.svg#arrow-down"></use>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c-admission-preparation__wrap js-admission-preparation__wrap">
                        <div class="c-admission-result">
                            <div v-for="(b) in blocks" class="c-admission-result__item">
                                <div class="o-grid">
                                    <div class="o-grid-4" v-html="b.leftCol">
                                    </div>
                                    <div class="o-grid-8">
                                        <div class="c-admission-result__content o-text" v-html="b.rightCol">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PersonnesRessources',
    data() {
        return {
            selectedFilter1: '',
            selectedFilter2: '',
        }
    },
    watch: {
        selectedFilter1() {
            this.selectedFilter2 = ""
            if (this.filter2.length == 1) {
                this.selectedFilter2 = this.filter2[0]
            }
        },
        selectedFilter2(newValue) {
            this.$emit('update:selectedFilter2', newValue)
        },
    },
    computed: {
        filter1() {
            let items = []

            personnesRessources.people.forEach((item) => {
                if (!items.includes(item.filter1) && item.filter1 !== null) {
                    items.push(item.filter1)
                }
            })

            items.sort((a, b) => {
                return a.localeCompare(b)
            })

            return items
        },
        filter2() {
            let items = []

            personnesRessources.people.forEach((item) => {
                if (item.filter1 == this.selectedFilter1 && item.filter2 !== null) {
                    if (!items.includes(item.filter2)) {
                        items.push(item.filter2)
                    }
                }
            })

            items.sort((a, b) => {
                return a.localeCompare(b)
            })

            return items
        },
        blocks() {
            let items = []
            let type = '';
            let departement = '';
            let departementUrl = '';
            let agentSuiviEmail = '';
            let agentGestionEmail = ''
            let directeurProgramme = '';
            let directeurProgrammeUrl = '';

            if (!this.selectedFilter1 || !this.selectedFilter2) {
                return items
            }

            personnesRessources.people.forEach((person) => {
                if (person.filter1 == this.selectedFilter1 && person.filter2 == this.selectedFilter2) {
                    type = person.type
                    agentSuiviName = person.agentSuiviName
                    agentSuiviEmail = person.agentSuiviEmail
                    agentGestionEmail = person.agentGestionEmail
                    directeurProgramme = person.directeurProgramme
                    directeurProgrammeUrl = person.directeurProgrammeUrl
                    departement = person.departement
                    departementUrl = person.departementUrl
                }
            })

            personnesRessources.blocks.forEach((item, idx) => {
                let btype = item.type
                let push = false

                if (btype == 'all') {
                    push = true
                }

                if (Array.isArray(btype) && btype.includes(type)) {
                    push = true
                }

                if (item.filter1 !== undefined && item.filter1 === this.selectedFilter1) {
                    push = true
                }

                if (this.selectedFilter2 == 'Stages post-doctoral' && idx > 0) {
                    push = false
                }

                if (item.force.includes(this.selectedFilter2)) {
                    push = true
                }

                if (item.exception.includes(this.selectedFilter2)) {
                    push = false
                }


                if ((item.leftCol.trim() == 'Departement' || item.leftCol.trim() == 'Département') && item.departmentException.length && item.departmentException.includes(departement)) {
                    // console.log(item, btype, departement)
                    push = false
                }

                if (!push) return


                let block = item;

                // leftcol format
                // take first and wrap it in <h4> tag
                let leftCol = block.leftCol
                let inP = false
                let inUl = false
                leftCol = leftCol.split('\n')
                leftCol = leftCol.map((l, i) => {
                    if (i == 0) {
                        return `<h4 class="o-title-4">${l}</h4>`
                    }
                    // if l contains a link
                    if (l.includes('<a')) {
                        return '<p>' + l + '</p>'
                    }
                    if (l.includes('@') && !l.includes('maito:')) {
                        return '<p><a href="mailto:' + l + '">' + l + '</a></p>'
                    }
                    return `<p><strong>${l}</strong></p>`
                }).join('')
                if (inUl) {
                    leftCol += '</ul>'
                }

                if ((idx == 2 || idx == 3 || idx == 4) && agentSuiviName !== null && agentSuiviName.length > 0) {
                    if (agentSuiviEmail !== null && agentSuiviEmail.includes('@')) {
                        leftCol += '<p><a href="mailto:' + agentSuiviEmail + '">' + agentSuiviEmail + '</a></p>';
                    } else if (agentSuiviEmail !== null) {
                        leftCol += '<p><a href="' + agentSuiviEmail + '">' + agentSuiviEmail + '</a></p>';
                    } else if (agentSuiviName !== null) {
                        leftCol += '<p>' + agentSuiviName + '</p>';
                    }
                } else if ((idx == 2 || idx == 3 || idx == 4) && agentSuiviEmail === null) return;
                if ((idx == 5 || idx == 6 || block.leftCol.trim() == 'Departement' || block.leftCol.trim() == 'Département') && departement !== null && departement.length > 0) {
                    if (departementUrl.includes('@')) {
                        leftCol += '<p><a href="mailto:' + departementUrl + '">' + departement + '</a></p>';
                    } else {
                        leftCol += '<p><a href="' + departementUrl + '">' + departement + '</a></p>';
                    }
                } else if ((idx == 5 || idx == 6) && departement === null) return;
                if (idx == 8 && agentGestionEmail !== null && agentGestionEmail.length > 0) {
                    if (agentGestionEmail.includes('@')) {
                        leftCol += '<p><a href="mailto:' + agentGestionEmail + '">' + agentGestionEmail + '</a></p>';
                    } else {
                        leftCol += '<p><a href="' + agentGestionEmail + '">' + agentGestionEmail + '</a></p>';
                    }
                } else if (idx == 8 && agentGestionEmail === null) return;
                if ((idx == 9 || idx == 12) && directeurProgramme !== null && directeurProgramme.length > 0) {
                    if (directeurProgrammeUrl.includes('@')) {
                        leftCol += '<p><a href="mailto:' + directeurProgrammeUrl + '">' + directeurProgramme + '</a></p>';
                    } else {
                        leftCol += '<p><a href="' + directeurProgrammeUrl + '">' + directeurProgramme + '</a></p>';
                    }
                } else if ((idx == 9 || idx == 12) & directeurProgramme === null) return;

                let rightCol = block.rightCol || ''
                inP = false
                inUl = false
                if (rightCol != '') {
                    rightCol = rightCol.split('\n')
                    rightCol = rightCol.map((l) => {

                        // check if line ends with :
                        if (l.endsWith(':')) {
                            inP = true
                            inUl = true
                            return `<p>${l}<ul>`
                        }

                        if (inUl) {
                            if (l == '') {
                                inUl = false
                                return '</ul>'
                            }
                            return `<li>${l}</li>`
                        }

                        inUl = true
                        return `<ul><li>${l}</li>`
                    }).join('')

                    if (inUl) {
                        rightCol += '</ul>'
                    }
                }

                items.push({
                    id: idx,
                    leftCol: leftCol,
                    rightCol: rightCol,
                })
            })

            return items
        },
    },
    methods: {
        t(string) {
            return PersonnesRessourcesLocalisation[string]
        },
        formatFilter(filter) {
            if (filter.includes('1er')) {
                filter = filter.replace('1er', '1ᵉʳ');
            }
            if (filter.includes('2e')) {
                filter = filter.replace('2e', '2ᵉ');
            }
            if (filter.includes('3e')) {
                filter = filter.replace('3e', '3ᵉ');
            }
            return filter
        },
    }
}
</script>
